export { default } from './BuildingIcon';
